export default __webpack_public_path__ + "f57390a12c566f77d76f05b1ed1b96bc.png";